module.exports = __webpack_public_path__ + "files/84a567805c43eb7aaa45a875679623be.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/exo2-bolditalic-webfont.svg
 ** module id = 912
 ** module chunks = 0
 **/